export class ContentAlertAdvisories {
  alertAdvisoriesLabel: any;
  viewAllAdvisoriesLabel: any;
  viewAllAdvisoriesLink: any;
  advisoriesNewWindow: any;
  defaultDisplay: any;
  advisoriesList: AlertAdvisoriesItem[];

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['alertAdvisoriesLabel']) {
        this.alertAdvisoriesLabel = contentjson['alertAdvisoriesLabel'];
      }
      if (contentjson['viewAllAdvisoriesLabel']) {
        this.viewAllAdvisoriesLabel = contentjson['viewAllAdvisoriesLabel'];
      }
      if (contentjson['viewAllAdvisoriesLink']) {
        this.viewAllAdvisoriesLink = contentjson['viewAllAdvisoriesLink'];
      }
      if (contentjson['advisoriesNewWindow']) {
        this.advisoriesNewWindow = contentjson['advisoriesNewWindow'];
      }
      if (contentjson['defaultDisplay']) {
        this.defaultDisplay = contentjson['defaultDisplay'];
      }
      if (contentjson['ApplicationAdvisoriesList']) {
        this.advisoriesList = this.fillAlertAdvisorieslist(
          contentjson['ApplicationAdvisoriesList']
        );
      }
    }
  }

  private fillAlertAdvisorieslist(contentjson?: any): AlertAdvisoriesItem[] {
    const alertadvisorieslist: AlertAdvisoriesItem[] = [];
    for (const item of contentjson) {
      alertadvisorieslist.push(new AlertAdvisoriesItem(item));
    }
    return alertadvisorieslist;
  }
}

export class AlertAdvisoriesItem {
  title: any;
  apptype: any;
  pageUrl: any;
  key: any;

  constructor(contentjson?: any) {
    if (contentjson['title']) {
      this.title = contentjson['title'];
    } else {
      this.title = '';
    }
    if (contentjson['apptype']) {
      this.apptype = contentjson['apptype'];
    } else {
      this.apptype = '';
    }
    if (contentjson['pageUrl']) {
      this.pageUrl = contentjson['pageUrl'];
    } else {
      this.pageUrl = '';
    }
    if (contentjson['advisoryKey']) {
      this.key = contentjson['advisoryKey'];
    } else {
      this.key = '';
    }
  }
}
